module.exports = __webpack_public_path__ + "img/herbed-new-potato-salad.19cb7255.jpg";